import { PaginationDataGrid } from './PaginationDataGrid';

enum ModelType {
  TENDER = 'TENDER',
  DELIVERY_DRIVER = 'DELIVERY_DRIVER',
  DELIVERY_DRIVER_WITH_ACTIONS = 'DELIVERY_DRIVER_WITH_ACTIONS',
  COST = 'COST',
  COST_WITH_ACTIONS = 'COST_WITH_ACTIONS',
}

export { ModelType, PaginationDataGrid };
